module.exports = __webpack_public_path__ + "img/canteen_bind_phone.98d56419.png";